import React from 'react';
import Icon from 'components/AppIcon';

const TeamMetrics = () => {
  const metrics = [
    {
      value: "18+",
      label: "Années d\'Expérience Cumulée",
      icon: "Calendar",
      color: "blue",
      description: "D\'expertise technique approfondie"
    },
    {
      value: "50+",
      label: "Certifications Professionnelles",
      icon: "Award",
      color: "green",
      description: "Dans tous nos domaines d'expertise"
    },
    {
      value: "200+",
      label: "Projets Réalisés avec Succès",
      icon: "CheckCircle",
      color: "purple",
      description: "Clients satisfaits et transformés"
    },
    {
      value: "15+",
      label: "Domaines de Spécialisation",
      icon: "Target",
      color: "orange",
      description: "Couvrant tous vos besoins business"
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-3 bg-red-50 text-red-600 px-6 py-3 rounded-full font-semibold text-sm mb-8">
            <Icon name="BarChart3" size={20} />
            <span>Nos Chiffres Clés</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">L'Excellence Mesurable</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des indicateurs qui témoignent de notre engagement et de notre expertise collective au service de votre réussite
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics?.map((metric, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-3 transition-all duration-300 border border-gray-100 relative overflow-hidden">
                {/* Background Gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br from-${metric?.color}-50 to-${metric?.color}-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`w-16 h-16 bg-${metric?.color}-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon name={metric?.icon} size={32} className={`text-${metric?.color}-600`} />
                  </div>

                  {/* Metric Value */}
                  <div className="text-center space-y-4">
                    <h3 className="text-4xl font-bold text-gray-900 group-hover:text-white transition-colors duration-300">
                      {metric?.value}
                    </h3>
                    <h4 className="text-lg font-semibold text-gray-800 group-hover:text-white transition-colors duration-300 leading-tight">
                      {metric?.label}
                    </h4>
                    <p className="text-sm text-gray-600 group-hover:text-gray-200 transition-colors duration-300 leading-relaxed">
                      {metric?.description}
                    </p>
                  </div>

                  {/* Progress Indicator */}
                  <div className="mt-6 pt-6 border-t border-gray-100 group-hover:border-white/20">
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className={`bg-gradient-to-r from-${metric?.color}-500 to-${metric?.color}-600 h-2 rounded-full transition-all duration-1000 ease-out`}
                        style={{ width: '85%' }}
                      ></div>
                    </div>
                    <p className="text-xs text-gray-500 group-hover:text-gray-300 mt-2 text-center">
                      Excellence continue
                    </p>
                  </div>
                </div>

                {/* Decorative Corner */}
                <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-${metric?.color}-200 to-${metric?.color}-300 rounded-bl-3xl opacity-20`}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="flex items-center justify-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                <Icon name="TrendingUp" size={24} className="text-red-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Performance en Croissance Continue</h3>
            </div>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
              Ces chiffres reflètent notre engagement constant vers l'excellence et l'innovation. Chaque projet nous permet d'enrichir notre expertise collective.
            </p>
            <button className="inline-flex items-center space-x-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200">
              <Icon name="Users" size={20} />
              <span>Rencontrer l'Équipe</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamMetrics;